import { IAddress } from './address';

export class IMemberContact {
    _id: string;
    contact: string;
    contactHome: string;
    contactwork: string;
    address: IAddress;
    subscribeEmail: boolean;
    subscribeSMS: boolean;
}